import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { hasCachedSettings, loadSiteSettings } from './lib/siteSettings'
import { forgetExpiredCheckout } from './lib/checkoutExpiry'

// A booking left unpaid past the payment window starts again from scratch (it was removed on the server).
forgetExpiredCheckout()

const start = () => createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Tour prices, photos and booking rules come from the server (edited in the admin). A returning visitor
// starts with the copy saved on the last visit and refreshes it in the background; a first visit waits a
// moment for the server so it does not flash the old prices, but never longer than 900 ms.
if (hasCachedSettings()) {
  start()
  void loadSiteSettings()
} else {
  Promise.race([loadSiteSettings(), new Promise((resolve) => setTimeout(resolve, 900))]).finally(start)
}